<template>
    <div>
        <div class="flex justify-center">
            <vs-card class="sm:w-10/12 md:w-9/12 lg:w-7/12 xl:w-6/12 mt-5 shadow-lg card relative">
                <form ref="form" @submit.prevent="validate" class="flex flex-col items-center">
                    <div class="w-10/12 mt-10 text-center">
                        <!-- <h2 class="mb-4">Success</h2>
                        <h3 class="mb-4">Thanks for redeeming the Coupon, you can now access content in the app</h3> -->
                        <h1>Thank you for registering!</h1>
                        <div class="w-full flex justify-center mt-5">
                            <img src="@/assets/images/checkmark-64.png" alt="green mark" />
                        </div>
                        <p class="mt-5">
                            You have successfully registered <br />
                            Feel free to download the app through links below. <br />
                        </p>
                    </div>
                    <app-links />
                    <img
                        src="@/assets/images/croc.png"
                        height="250"
                        alt="Croc Image"
                        class="croc"
                    />
                </form>
            </vs-card>
        </div>
    </div>
</template>

<script>
import { mapParams } from '@/plugins/mappers'
import AppLinks from './AppLinks.vue'

export default {
    name: 'register-success',
    computed: {},
    watch: {},
    components: {
        AppLinks
    },
    data() {
        return {}
    },
    methods: {
        validate() {
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                }
            })
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700;800&display=swap');
h1 {
    color: #848a8a;
}
.croc {
    position: absolute;
    left: -50px;
    bottom: 0;
}
#logo {
    background-color: #b7dcc9;
}
.margin-left {
    margin-left: -180%;
}
.card {
    border-radius: 30px;
    height: 700px;
    max-width: 650px;
}
input {
    color: #949c9c;
}
input:focus {
    box-shadow: 0px 4px 10px -6px;
}
.border-bottom {
    border-top: none;
    border-left: none;
    border-right: none;
    border-color: #bcbdbe;
}
::placeholder {
    color: #bcbdbe;
}
.sign-up {
    border: none;
    border-radius: 50px;
    background-color: #9dd6cd;
    color: #fff;
    font-size: 1.5rem;
    box-shadow: 0px 2px 6px 0.5px #bebebe;
    cursor: pointer;
    font-family: 'Playfair Display', serif;
}
a {
    font-size: 1rem;
}
.error {
    color: #f72415;
}
p {
    color: #848a8a;
    line-height: 20px;
    font-size: 0.9rem;
}
li {
    color: #949c9c;
    font-size: 1.2rem;
}
li span {
    font-size: 1rem;
}
@media only screen and (min-height: 1200px) {
    .card {
        height: 800px;
    }
    .height {
        height: 1202px;
    }
}
@media only screen and (max-width: 650px) {
    .croc {
        display: none;
    }
}
</style>
